import { stat } from 'fs';
import { DeNghiMuaHangService } from './../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { select } from '@ngrx/store';
import { Component, OnInit, ElementRef, ViewChildren, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Inject, HostListener, ViewRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { YeuCauDuyetGiaService } from '../yeu-cau-duyet-gia-service/yeu-cau-duyet-gia.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { YeuCauDuyetGia, YeuCauDuyetGiaChiTiet, DanhSachYCDG, YCDG, YeuCauDuyetGiaConfig } from '../yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { TimKiemNangCaoListComponent } from '../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { FlexAlignStyleBuilder } from '@angular/flex-layout';
import { KDDatHangService } from '../../kd-dat-hang/kd-dat-hang-service/kd-dat-hang.service';
import { KhachHangFeedbackComponent } from '../khach-hang-feedback/khach-hang-feedback.component';
import { YeuCauBaoGia, YeuCauBaoGiaConfig } from '../../kd-yeu-cau-bao-gia-dialog/kd-yeu-cau-bao-gia-dialog-model/kd-yeu-cau-bao-gia-dialog.model';
import { YeuCauBaoGiaService } from '../../kd-yeu-cau-bao-gia-dialog/kd-yeu-cau-bao-gia-dialog-service/kd-yeu-cau-bao-gia-dialog.service';
import { YeuCauBaoGiaDetailComponent } from '../../kd-yeu-cau-bao-gia-dialog/kd-yeu-cau-bao-gia-dialog-detail/kd-yeu-cau-bao-gia-dialog-detail.component';

@Component({
	selector: 'm-yeu-cau-duyet-gia-edit',
	templateUrl: './yeu-cau-duyet-gia-edit.component.html',
	styleUrls: ['../yeu-cau-duyet-gia.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class YeuCauDuyetGiaEditComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	/* Các trường focus cho các tag trong form */
	@ViewChildren('focusMaKH') focusMaKH;
	@ViewChildren('focusGhiChu') focusGhiChu;
	@ViewChildren('focusThue') focusThue;
	@ViewChildren('focusGiaMoi') focusGiaMoi;
	@ViewChildren('focusSL') focusSL;
	@ViewChildren('focusDetail') focusDetail;
	@ViewChildren('focusLyDo') focusLyDo;
	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MAHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TENHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QUYCACH',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DONVITINH',
			displayName: 'Đon vị tính',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONG',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'NGAYYEUCAUGIAOHANG',
			displayName: 'Ngày yêu cầu giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'THOIGIANGIUGIA',
			displayName: 'Thời gian giữ giá',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'LOAITIEN',
			displayName: 'Loại tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GIAMOI',
			displayName: 'Giá mới',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'TONGSLTON',
			displayName: 'Tổng SL tồn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'SOLO',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'SLTON',
			displayName: 'SL Tồn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GIARECOMMAND',
			displayName: 'Giá recommand',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'THANHTIEN',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'THANHTIENQUYDOI',
			displayName: 'Thành tiền quy đổi',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'TRANGTHAI',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
	];
	extendsColumn = [
		{
			stt: 99,
			name: 'ACTIONS',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		},
	];
	listidHH: any[] = [
		{
			value: '5',
			name: 'Bán thành phẩm'
		},
		{
			value: '4',
			name: 'Thành phẩm'
		}
	];
	displayedColumnsf = [];
	availableColumnsf = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		// {
		// 	stt: 2,
		// 	name: 'SOPHIEU',
		// 	displayName: 'Số phiếu',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		{
			stt: 3,
			name: 'MAKH',
			displayName: 'Mã KH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TENKH',
			displayName: 'Tên KH',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'SOLUONG',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'DVT',
			displayName: 'DVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GIAKHACHHANGMONGMUON',
			displayName: 'Giá KH đề nghị',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'GIAMIN',
			displayName: 'Giá min',
			alwaysChecked: false,
			isShow: true
		},
		// {
		// 	stt: 8,
		// 	name: 'GIAMAX',
		// 	displayName: 'Giá max',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		{
			stt: 9,
			name: 'GIADENGHIBAN',
			displayName: 'Giá đề nghị bán',
			alwaysChecked: false,
			isShow: true
		},
		// {
		// 	stt: 11,
		// 	name: 'LOAITIEN',
		// 	displayName: 'Loại tiền',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		// {
		// 	stt: 12,
		// 	name: 'TYGIA',
		// 	displayName: 'Tỷ giá',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		// {
		// 	stt: 13,
		// 	name: 'THANHTIEN',
		// 	displayName: 'Thành tiền',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		// {
		// 	stt: 14,
		// 	name: 'THANHTIENQUYDOI',
		// 	displayName: 'Thành tiền quy đổi',
		// 	alwaysChecked: false,
		// 	isShow: true
		// },
		{
			stt: 14,
			name: 'NGAYYEUCAUGIAOHANG',
			displayName: 'Ngày yêu cầu giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'KLSaiSo',
			displayName: '%KL sai số cho phép',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'KHFeedback',
			displayName: 'Khách hàng feedback',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'ACTIONS',
			displayName: 'Thao tác',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 19,
			name: 'THAMCHIEU',
			displayName: 'Tham chiếu',
			alwaysChecked: true,
			isShow: true
		},
	];
	extendsColumnf = [
		{
			stt: 15,
			name: 'TRANGTHAI',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'NGAYDUYET',
			displayName: 'Ngày duyệt',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 17,
			name: 'NGUOIDUYET',
			displayName: 'Người duyệt',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 18,
			name: 'LYDO',
			displayName: 'Lý do',
			alwaysChecked: true,
			isShow: true
		},
		
	];
	selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
	/* End comment columns mat-table -------------------------------------*/
	/* Mat select search cho nhà cung cấp */
	listListNCC: any[] = [];
	selectListNCC: string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho khach hang */
	listListKH: any[] = [];
	selectListKH: string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho hàng hóa */
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho hop dong */
	listHD: any[] = [];
	selectHD: string = '';
	filteredHD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HDFilterCtrl: string = '';
	haveElementHD: boolean = false;
	listYCBG: any[] = [];
	selectYCBG: string = '';
	filteredYCBG: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	YCBGFilterCtrl: string = '';
	haveElementYCBG: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	selectQuyetDinhLoHang = '0';
	/* ------------------------------------------------------------------ */
	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<YeuCauDuyetGiaChiTiet>(true, []);
	/* ------------------------------------------------------------------ */
	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */
	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   // Loading khi mở dialog
	canEdit: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */
	/* Các Sub form trên dialog:  */
	MainForm: FormGroup;				//Form phiếu đề nghị
	ConfirmForm: FormGroup;			//Form add hàng hóa cho phiếu
	TitleTable: FormGroup;
	/* ------------------------------------------------------------------ */
	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	YCDG: YCDG;
	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: YeuCauDuyetGiaChiTiet[] = [];
	/* Danh sách chi tiết hàng hóa của phiếu đề nghị lúc đầu dùng để so sánh -> cập nhập trạng thái phiếu */
	compareChiTietHangVe: YeuCauDuyetGiaChiTiet[] = [];
	/* Danh sách tình trạng phiếu */
	/* hàng hóa */
	list_HH: any[] = [];
	select_HH: string = '';
	filtered_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HH_FilterCtrl: string = '';
	//
	list_KH: any[] = [];
	select_KH: string = '';
	filtered_KH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KH_FilterCtrl: string = '';
	TinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'KDYCDG_DANGSOANTHAO',
		},
		{
			id: 2,
			name: 'Chờ duyệt',
			value: 'KDYCDG_CHODUYET',
		},
		{
			id: 3,
			name: 'Không duyệt',
			value: 'KDYCDG_KHONGDUYET',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'KDYCDG_HOANTAT',
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'KDYCDG_DAHUY',
		},
		{
			id: 6,
			name: 'Đã xóa',
			value: 'KDYCDG_DAXOA',
		},
		,
		{
			id: 7,
			name: 'Đang thực hiện',
			value: 'KDYCDG_DANGTHUCHIEN',
		}
	];
	show_area_1: boolean = false;
	add: boolean = false;
	edit: boolean = false;
	confirm: boolean = false;
	detail: boolean = false;
	arrIdHangHoa = [];
	currency_unit = [];
	danh_sach_lot = [];
	keywordSoLo = '';
	tiente_id_default = 0;
	tiente_name_default = '';
	listTonKhoHienTai: any[] = [];
	minDate = moment(new Date()).format('YYYY-MM-DD');
	openFormKH: boolean = false;
	payments = [];
	GiaCu: number;
	isOpenDialog: boolean = false;

	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode && !this.isOpenDialog) {
			this.back();
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE.KeyCombine.keycode && (this.add || this.edit)) {
			this.setYeuCauDuyetGia(1);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode && (this.add || this.edit)) {
			this.setYeuCauDuyetGia(2);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode && (this.add || this.edit)) {
			this.setYeuCauDuyetGia(0);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.NOT_CONFIRM.KeyCombine.keycode && this.confirm) {
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.CONFIRM.KeyCombine.keycode && this.confirm) {
		}
		if (this.isOpenDialog) this.isOpenDialog = !this.isOpenDialog;
	}
	_idsp: number = 0;
	_idYCBG: number = 0;
	_idHH: string = '';
	_matenKH: string = '';
	isSuccess: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<YeuCauDuyetGiaEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private YeuCauDuyetGiaService: YeuCauDuyetGiaService,
		private YeuCauBaoGiaService: YeuCauBaoGiaService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private MainFormFB: FormBuilder,
		private ConfirmFormFB: FormBuilder,
		private TitleTableFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private deNghiMuaHangService: DeNghiMuaHangService,
		private KDDatHangService: KDDatHangService,
		private router : Router

	) {
		this.dialogRef.disableClose = true;
	}

	/** LOAD DATA */
	async ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.show_area_1 = this.data.show_area_1 ? this.data.show_area_1 : false;
		this.add = this.data.add ? this.data.add : false;
		this.edit = this.data.edit ? this.data.edit : false;
		this.detail = this.data.detail ? this.data.detail : false;
		this.confirm = this.data.confirm ? this.data.confirm : false;
		this._matenKH = this.data.matenKH ? this.data.matenKH : '';
		this.YCDG = new YCDG();
		this.YCDG.clear();
		this.getListHHMultiple();
		this.getListKHMultiple();
		this.createForm();
		await this.getPayments();
		let __idDG = this.data.data.IdDG;

		if (this.add) {
			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
			this.MainForm.controls['NGUOILAPPHIEU'].setValue(tenNguoiLap);
			this.createBillNumber().then(r => { this.MainForm.controls['SOPHIEU'].setValue(r); });

			if (this.data.listDetail && this.payments.length > 0) {
				let controls = this.MainForm.controls;
				controls['MAKH'].setValue('' + this.data.listDetail[0].IdKH);
				controls['TENKH'].setValue('' + this.data.listDetail[0].TenKH);
				if (this.invalidForm(this.MainForm) == false)
					return;
				let tiente = this.payments.find(x => x.Id == Number(controls['LOAITIEN'].value));
				this.data.listDetail.forEach(x => {
					let tmp = new DanhSachYCDG();
					tmp.copy(x);
					tmp.TienTe_Ten = tiente.Ten;
					tmp.TienTe_Id = Number(controls['LOAITIEN'].value.toString());
					tmp.TyGia = this.formatComparenumber(controls['TYGIA'].value.toString());
					tmp.ThanhTien = 0;
					tmp.ThanhTienQuyDoi = 0;
					tmp.TrangThai = 'Đang soạn thảo';
					tmp.TrangThai_Code = this.TinhTrang[0].value;

					this.YCDG.YeuCauDuyetGiaDetailCT.push(tmp);
				})
				let it = this.YCDG.YeuCauDuyetGiaDetailCT;
				this.YCDG.YeuCauDuyetGiaDetailCT = [];
				this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
			}
			if (this.data && this.data.data && Array.isArray(this.data.data.DanhSachHangHoa) && this.data.data.DanhSachHangHoa.length > 0 && Array.isArray(this.payments) && this.payments.length > 0) {
				let controls = this.MainForm.controls;
				controls['MAKH'].setValue('' + this.data.data.DanhSachHangHoa[0].IdKH);
				controls['TENKH'].setValue('' + this.data.data.DanhSachHangHoa[0].TenKH);
				if (this.invalidForm(this.MainForm) == false)
					return;
				let tiente = this.payments.find(x => x.Id == Number(controls['LOAITIEN'].value));
				this.data.data.DanhSachHangHoa.forEach(x => {
					let tmp = new DanhSachYCDG();
					tmp.copy(x);
					tmp.TienTe_Ten = tiente.Ten;
					tmp.TienTe_Id = Number(controls['LOAITIEN'].value.toString());
					tmp.TyGia = this.formatComparenumber(controls['TYGIA'].value.toString());
					tmp.ThanhTien = 0;
					tmp.ThanhTienQuyDoi = 0;
					tmp.TrangThai = 'Đang soạn thảo';
					tmp.TrangThai_Code = this.TinhTrang[0].value;

					this.YCDG.YeuCauDuyetGiaDetailCT.push(tmp);
				})
				let it = this.YCDG.YeuCauDuyetGiaDetailCT;
				this.YCDG.YeuCauDuyetGiaDetailCT = [];
				this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
			}
			// this.changeDetect.detectChanges();
		}
		else {
			if (this.detail) {
				this.availableColumnsf.push(
					{
						stt: 10,
						name: 'THOIHANGIUGIA',
						displayName: 'Thời hạn giữ giá',
						alwaysChecked: false,
						isShow: true
					})
				this.extendsColumnf.forEach(element => {
					this.availableColumnsf.splice(this.availableColumnsf.length, 0, element);
				});
				this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
			}
			this.YeuCauDuyetGiaService.detail(__idDG).subscribe(res => {
				if (res && res.status === 1) {
					this.YCDG = res.data[0];
					this.createForm();
					this.changeDetectView();
				}
			});
		}

		this.showColumnsInTablef();
		this.applySelectedColumnsf();
		this.changeDetect.detectChanges()
	}

	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case "KDYCDG_DANGSOANTHAO":
				return '_phieumoi';
			case "KDYCDG_CHODUYET":
				return '_choxacnhan';
			case "KDYCDG_KHONGDUYET":
				return '_tpkhongduyet';
			case "KDYCDG_HETHAN":
				return '_hethan';
			case "KDYCDG_HOANTAT":
				return '_hoantat';
			case "KDYCDG_DAHUY":
				return '_dahuy';
			case "KDYCDG_CHOXUATKHO":
				return '_chotpduyet';
			default:
				return 'success';
		}
	}

	showColumnsInTablef() {
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			if (this.availableColumnsf[i].isShow == false) {
				this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			}
		}
	}

	applySelectedColumnsf() {
		let _selectedColumns = this.selectedColumnsf.selected;
		this.selectedColumnsf = new SelectionModel<any>(true, this.availableColumnsf);
		for (let i = 0; i < this.availableColumnsf.length; i++) {
			this.selectedColumnsf.toggle(this.availableColumnsf[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumnsf[i].name == _selectedColumns[j].name) {
					this.selectedColumnsf.toggle(this.availableColumnsf[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumnsf.selected.forEach(col => {
			_applySelectedColumns.push(col.name);
		});
		this.displayedColumnsf = _applySelectedColumns;
	}

	async getPayments() {
		let resCurrency = await this.KDDatHangService.getConfigDefaultCurrency().toPromise();
		if (resCurrency && resCurrency.status === 1) {
			let idDefaultCurrency = Number(resCurrency.data);

			let res = await this.DungChungService.getDSTienTe().toPromise();
			if (res && res.status === 1) {
				this.payments = res.data;

				let indexVND = this.payments.findIndex(x => +x.Id == idDefaultCurrency);
				if (indexVND > -1)
					this.MainForm.controls['LOAITIEN'].setValue(this.payments[indexVND].Id.toString());
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
			this.changeDetectView();
		}
	}

	ngAfterViewInit() {
		/*Focus on first input field*/
		//this.changeDetect.detectChanges();
		this.changeDetectView();
	}

	//#region checkPositiveNumbers
	kiemTraGiaTriMin(event, min: number = 0) {
		FunctionPublic.kiemTraGiaTriMin(event, min);
	}
	//#endregion checkPositiveNumbers

	/*Create Form with appropriate sub forms */
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		var item = this.YCDG;
		this.MainForm = this.MainFormFB.group({
			SOPHIEU: [item.SoPhieu, Validators.required],
			NGAYLAPPHIEU: [item.NgayLapPhieu ? item.NgayLapPhieu : new Date(), Validators.required],
			NGUOILAPPHIEU: [item.TenNguoiLapPhieu, Validators.required],
			NGAYYEUCAUBAOGIA: [item.NgayYeuCauBaoGia ? item.NgayYeuCauBaoGia : new Date(), Validators.required],
			LOAITIEN: [item.YeuCauDuyetGiaDetailCT.length > 0 ? item.YeuCauDuyetGiaDetailCT[0].TienTe_Id + '' : '', Validators.required],
			TYGIA: [item.YeuCauDuyetGiaDetailCT.length > 0 ? this.f_currency_VND(this.formatNumber(item.YeuCauDuyetGiaDetailCT[0].TyGia.toString())) : '1,00'],
			MAKH: [item.YeuCauDuyetGiaDetailCT.length > 0 ? item.YeuCauDuyetGiaDetailCT[0].IdKH + '' : '', Validators.required],
			TENKH: [item.YeuCauDuyetGiaDetailCT.length > 0 ? item.YeuCauDuyetGiaDetailCT[0].TenKH + '' : ''],
		});
		this.MainForm.controls['SOPHIEU'].disable();
		this.MainForm.controls['NGUOILAPPHIEU'].disable();
		this.MainForm.controls['NGAYLAPPHIEU'].disable();
		this.MainForm.controls['TENKH'].disable();

		if (this.detail || this.confirm) {
			this.MainForm.controls['LOAITIEN'].disable();
			this.MainForm.controls['TYGIA'].disable();
			this.MainForm.controls['MAKH'].disable();
			this.MainForm.controls['NGAYYEUCAUBAOGIA'].disable();
		}
	}

	getTitle(): string {
		if (this.add) return 'THÊM MỚI YÊU CẦU DUYỆT GIÁ';
		if (this.edit) return 'CHỈNH SỬA YÊU CẦU DUYỆT GIÁ';
		if (this.confirm) return 'DUYỆT YÊU CẦU DUYỆT GIÁ';
		if (this.detail) return 'CHI TIẾT YÊU CẦU DUYỆT GIÁ';
	}

	/*Xóa dữ liệu hàng hóa trong bảng*/
	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Các hàm hỗ trợ cho mat select search Nhà cung cấp*/
	/*Hàm hỗ trợ format các dạng số trên form*/
	formatNumber(item: string) {
		if (!item) return '0.00';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0,00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
	}
	/*------------------------------------------------------------- */
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/*------------------------------------------------------------- */
	//#region Tạo số phiếu tự động
	async createBillNumber() {
		var category_path = "YCDG";
		var res = await this.DungChungService.getBillNumber(category_path).toPromise().then(r => { return r });
		if (res && res.status == 1) {
			return res.data;
		}
		else {
			this.layoutUtilsService.showErorr("Không thể lấy số phiếu tự động.");
		}
	}
	//#endregion Tạo số phiếu tự động

	/* Kiểm tra gửi duyệt */
	/* Mở danh sách phiếu đề nghị */
	back() {
		if(this.YCDG.YeuCauDuyetGiaDetailCT.length >0){
			const dialogRef = this.layoutUtilsService.POPConfirm('Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.dialogRef.close({
					isChange: this.isChange,
					saveNewTTHV: this.saveAddedTTHV,
					isSuccess: this.isSuccess
				});
			});
		}
		else{
			this.dialogRef.close({
				isChange: this.isChange,
				saveNewTTHV: this.saveAddedTTHV,
				isSuccess: this.isSuccess
			});
		}
		
	}
	validateInvalidForm(isAddDetail: boolean = false) {
		const controls = this.MainForm.controls;
		if (this.MainForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = this.MainForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return false;
		}
		if (!isAddDetail) {
			setTimeout(() => this.focusDetail.first.nativeElement.focus(), 100);
		}
		return true;
	}
	closeDropdownEvent(dropdownName: string) {
		if (dropdownName == 'MaKH') {
			setTimeout(() => this.focusMaKH.first.close(), 0);
			this.changeDetectView();
		}
		this.validateInvalidForm();
		this.changeDetectView();
	}
	forcusAnotherEmptyField(control: any) {
		Object.keys(control).forEach(controlName => {
			if (control[controlName].value == null || control[controlName].value == undefined
				|| control[controlName].value == '') {
				if (controlName == 'GHICHU') {
					setTimeout(() => this.focusGhiChu.first.nativeElement.focus(), 0);
				}
			}
			this.changeDetectView();
		});
	}

	async getListHHMultiple() {
		let res = await this.YeuCauDuyetGiaService.DanhSachHangHoa().toPromise();
		if (res && res.status === 1) {
			this.list_HH = res.data;
			this.filtered_HH.next(this.list_HH);
			if (this._idsp > 0) {
			}
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}
	filterHH() {
		if (!this.list_HH) {
			return;
		}
		// get the search keyword
		let search = this.HH_FilterCtrl;
		if (!search) {
			this.filtered_HH.next(this.list_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_HH.next(
			this.list_HH.filter(ts =>
				(ts.MaHH.toLowerCase().indexOf(search) > -1 || ts.SoPhieu.toLowerCase().indexOf(search) > -1 || ts.TenHH.toLowerCase().indexOf(search) > -1)
			)
		);
		this.changeDetectView();
	}
	async getListKHMultiple() {
		let res = await this.YeuCauDuyetGiaService.DanhSachKH(this.determineBusinessModel()).toPromise();
		if (res && res.status === 1) {
			this.list_KH = res.data;
			this.filtered_KH.next(this.list_KH);
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}
	filterKH() {
		if (!this.list_KH) {
			return;
		}
		// get the search keyword
		let search = this.KH_FilterCtrl;
		if (!search) {
			this.filtered_KH.next(this.list_KH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_KH.next(
			this.list_KH.filter(ts =>
				ts.MaKH.toLowerCase().indexOf(search) > -1 || ts.TenKH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	/*------------------------------------------ */
	dateToDDMMYYYY(__data: any) {
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2) + "/" + ("0" + (__date.getMonth() + 1)).slice(-2) + "/" + __date.getFullYear();
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");
	}
	keyUpInputNumber(event) {
		if (event.keyCode === 8 && event.target.value == '0') {
			event.preventDefault();
			return;
		};
		FunctionPublic.checkPositiveNumbers(event);
	}
	setYeuCauDuyetGia(status: number = 0) {
		if (this.YCDG.YeuCauDuyetGiaDetailCT.length == 0) {
			this.layoutUtilsService.showErorr("Chưa thêm mặt hàng");
			return;
		}

		let isError = this.YCDG.YeuCauDuyetGiaDetailCT.findIndex(x => +x.GiaMoi == 0);
		if (isError > -1) {
			this.layoutUtilsService.showErorr("Vui lòng nhập giá đề nghị bán");
			return;
		}

		let data = this.createItem();
		if (data) {
			
			if (status == 1 || status == 2) {
				data.TrangThai_Code = this.TinhTrang[1].value;
				const _sophieu: string = data.SoPhieu;
				const dialogRef = this.layoutUtilsService.POP02(_sophieu);
				dialogRef.afterClosed().subscribe(res => {
					if (!res) {
						return;
					}
					if (data.IdDG > 0) {
						this.YeuCauDuyetGiaService.edit(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
					} else {
						this.YeuCauDuyetGiaService.insert(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
					}
				});
			}
			else {
				data.TrangThai_Code = this.TinhTrang[0].value;
				if (data.IdDG > 0) {
					this.YeuCauDuyetGiaService.edit(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
				} else {
					this.YeuCauDuyetGiaService.insert(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
				}
			}
		}
	}

	//#region Goi sau khi service tra ve du lieu
	runAfterAddOrUpdate(res, withBack) {
		if (res && res.status == 1) {
			this.isChange = true;
			this.isSuccess = true;
			const message = `Yêu cầu duyệt giá đã được cập nhật thành công.`;
			this.layoutUtilsService.showInfo(message);
			//Cập nhật lại khi đã thêm
			this.saveAddedTTHV = [];
			this.saveAddedTTHV.push(res.data.Id);
			// Luu nháp
			if (withBack == 0) {
				this.add = false;
				this.edit = true;
				this.YCDG = res.data;
				this.changeDetectView();
				return;
			}
			// Lưu và thêm mới
			if (withBack == 2) {
				this.add = true;
				this.edit = false;
				this.resetForm();
				this.getListKHMultiple();
				this.changeDetectView();
				return;
			}
			// Lưu và trờ lại
			if (withBack == 1) {
				this.MainForm.reset();
				this.back();
			}
			this.isChange = true;
			this.back();
		}
		else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	resetForm() {
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		this.MainForm.controls['NGUOILAPPHIEU'].setValue(tenNguoiLap);
		this.createBillNumber().then(r => { this.MainForm.controls['SOPHIEU'].setValue(r); });
		this.MainForm.controls['NGAYYEUCAUBAOGIA'].setValue(new Date());
		this.MainForm.controls['LOAITIEN'].setValue('');
		this.MainForm.controls['TYGIA'].setValue('1,00');
		this.MainForm.controls['MAKH'].setValue('');
		this.MainForm.controls['TENKH'].setValue('');
		this.YCDG.IdDG = 0;
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.changeDetect.detectChanges();
	}
	//#endregion

	//#region Check Invalid form
	invalidForm(formGroup) {
		const controls = formGroup.controls;
		if (formGroup.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = formGroup.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return false;
		}
	}
	//#endregion

	//#region Reset Form
	//#endregion

	//#region TP, GD Duyet, Khong Duyet
	// code 'truongphong', 'giamdoc'
	//#endregion

	//#region Goi sau khi duyet khong duyet
	showAfterConfirm(_sophieu, res) {
		if (res && res.status === 1) {
			const message = 'Phiếu yêu cầu duyệt giá ' + _sophieu + ' cập nhật thành công.';
			this.layoutUtilsService.showInfo(message);
			this.isChange = true;
			this.saveAddedTTHV.push(res.data);
			this.back();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	//#endregion

	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu ,';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	changeKetLuan(recommand: number, giamoi: number) {
		if (giamoi < recommand) return 0;
		if (recommand == 0) return 1;
		if (giamoi >= recommand) return 2;
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	changeThanhTien() {
		var controls = this.MainForm.controls;
		var giaMoi = this.FormatCommaNumber(controls['SOLUONG'].value + '') + this.FormatCommaNumber(controls['GIAMOI'].value + '');
		controls['THANHTIEN'].setValue(this.f_currency_VND(this.formatNumber(giaMoi + '')));
		this.changeDetectView();
	}
	FormatCommaNumber(item: string) {
		return Number(item.replace(/,/g, ""));
	}

	createItem() {
		let controls = this.MainForm.controls;
		let item = {
			IdDG: this.YCDG.IdDG,
			SoPhieu: controls['SOPHIEU'].value,
			TrangThai_Code: '',
			YeuCauDuyetGiaDetailCT: this.YCDG.YeuCauDuyetGiaDetailCT,
			NgayYeuCauBaoGia: moment(controls['NGAYYEUCAUBAOGIA'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS'),
			BusinessModel: this.determineBusinessModel()

		}
		item.YeuCauDuyetGiaDetailCT.forEach(element => {
			element.NgayYeuCauGH = moment(element.NgayYeuCauGH).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		});
		return item;
	}
	private determineBusinessModel(): string {
		const urlSegment = this.router.url.split("/")[1];
		const isB2B = urlSegment === YeuCauDuyetGiaConfig.B2B.PARAM_REQUEST_PRICE || 
					  urlSegment === YeuCauBaoGiaConfig.B2B.PARAM_REQUEST_PRICE;
		return isB2B ? YeuCauDuyetGiaConfig.B2B.BUSINESS_TYPE : YeuCauDuyetGiaConfig.B2C.BUSINESS_TYPE;
	}
	detailPhieu(item: any) {
		const numericPart = item.match(/\d+/)[0];
		
		this.YeuCauBaoGiaService.getDataMaster(numericPart).subscribe(master => {
			// handle the master data if needed
			if(master.data){
				this.YeuCauBaoGiaService.getDetail({Id: numericPart}).subscribe(res => {
					if (res.status == 1) {	
						master.data.TinhTrang = res.data.TinhTrang
						master.data.listYeuCauBaoGiaCt = res.data.listYeuCauBaoGiaCt;
						master.data.isShowFromDuyetGia = true;
						const dialogRef = this.dialog.open(YeuCauBaoGiaDetailComponent, {
							data: { data: master.data },
							maxHeight: '90vh',
							width: '90vw'
						});
		
						dialogRef.afterClosed().subscribe(res => {
						});
					}
					else {
						this.layoutUtilsService.showErorr(res.error.message);
					}
				})
			}
		});
		
	}
	timKiemNangCao() {
		let controls = this.MainForm.controls;
		if (this.invalidForm(this.MainForm) == false) return;

		this.isOpenDialog = true;
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw: '',
				idKH: controls['MAKH'].value,
				data: this.YCDG.YeuCauDuyetGiaDetailCT
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					this.ThemMatHang(res.dataAdd);
					this.changeDetect.detectChanges();
				}
			}
		});
	}
	openKHFeedback(item:any) {
		
		const dialogRef = this.dialog.open(KhachHangFeedbackComponent, {
			data: item,
			maxHeight: '90vh',
			width: '60vw'
		});
		dialogRef.afterClosed().subscribe(res => {
		});
	}
	ThemMatHang(data: any[]) {
		if (this.invalidForm(this.MainForm) == false) return;
		let controls = this.MainForm.controls;
		let tiente = this.payments.find(x => x.Id == Number(controls['LOAITIEN'].value));
		for (let j = 0; j < this.list_HH.length; j++) {
			if (data.includes(this.list_HH[j].Id_CT)) {
				var itemHH = this.list_HH[j];
				let tmp = new DanhSachYCDG();
				tmp.YCBGCT = this.list_HH[j].Id_CT;
				tmp.IdHH = itemHH.Id_HH;
				tmp.MaHH = itemHH.MaHH;
				tmp.IdDVT = itemHH.DVT;
				tmp.SoLuong = itemHH.SoLuong;
				tmp.TienTe_Ten = tiente.Ten;
				tmp.TienTe_Id = Number(controls['LOAITIEN'].value.toString());
				tmp.YCBG = itemHH.SoPhieu;
				tmp.MaKH = itemHH.MaKH;
				tmp.TenKH = itemHH.TenKH;
				tmp.TenHH = itemHH.TenHH;
				tmp.Min = itemHH.GiaMin;
				tmp.Max = itemHH.GiaMax;
				tmp.GiaKHDN = itemHH.GiaKhachHangMongMuon;
				tmp.TenDVT = itemHH.TenDVT;
				tmp.GiaMoi = 0;
				tmp.ThoiHanGiuGia = itemHH.ThoiGianGiuGia;
				tmp.NgayYeuCauGH = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				tmp.TyGia = this.formatComparenumber(controls['TYGIA'].value.toString());
				tmp.ThanhTien = 0;
				tmp.ThanhTienQuyDoi = 0;
				tmp.KLSaiSo = itemHH.KLSaiSo;
				tmp.TrangThai = 'Đang soạn thảo';
				tmp.TrangThai_Code = this.TinhTrang[0].value;
				let index = this.YCDG.YeuCauDuyetGiaDetailCT.find(x => x.YCBGCT == tmp.YCBGCT);
				if (index) {
					continue;
				}
				this.YCDG.YeuCauDuyetGiaDetailCT.push(tmp);
			}
		}
		let it = this.YCDG.YeuCauDuyetGiaDetailCT;
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
		this.changeDetect.detectChanges();
	}
	deleteIt(item: DanhSachYCDG) {
		let index = this.YCDG.YeuCauDuyetGiaDetailCT.indexOf(item, 0);
		if (index > -1) {
			this.YCDG.YeuCauDuyetGiaDetailCT.splice(index, 1);
		}
		let it = this.YCDG.YeuCauDuyetGiaDetailCT;
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
	}
	changeKH() {
		let controls = this.MainForm.controls;
		var itemKH = this.list_KH.find(x => x.IdKH == controls['MAKH'].value);
		if (itemKH != undefined)
			controls['TENKH'].setValue(itemKH.TenKH);
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.changeDetect.detectChanges();
	}
	changeHH() {
		// this.MainForm.controls['TYGIA'].enable();
		//this.MainForm.controls['GIAMOI'].enable();
	}

	changeInputNumberVND(event, min: number = 0, item: any) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.formatComparenumber(data) < min && event.data && event.data == '0')
					data = this.f_currency_VND(this.formatNumber(min.toString()));
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			} else {
				event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
			}
		}
		if (item) {
			let controls = this.MainForm.controls;
			let index = this.YCDG.YeuCauDuyetGiaDetailCT.indexOf(item, 0);
			this.YCDG.YeuCauDuyetGiaDetailCT[index].GiaMoi = this.formatComparenumber(event.target.value);
			this.YCDG.YeuCauDuyetGiaDetailCT[index].ThanhTien = this.YCDG.YeuCauDuyetGiaDetailCT[index].GiaMoi * this.YCDG.YeuCauDuyetGiaDetailCT[index].SoLuong;
			this.YCDG.YeuCauDuyetGiaDetailCT[index].ThanhTienQuyDoi = this.formatComparenumber(controls['TYGIA'].value) * this.YCDG.YeuCauDuyetGiaDetailCT[index].ThanhTien;
			let it = this.YCDG.YeuCauDuyetGiaDetailCT;
			this.YCDG.YeuCauDuyetGiaDetailCT = [];
			this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
		}
		this.changeDetect.detectChanges();
	}
	changeInputOfFormVND(event: any, min: number = 0, item: any) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");
			if (Number(tmpValue) < min) tmpValue = min;
			if (event.target.value) {
				event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			event.target.value = this.f_currency_VND(this.formatNumber(tmpValue));
		}
		else {
			event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
		}
		if (item) {
			let controls = this.MainForm.controls;
			let index = this.YCDG.YeuCauDuyetGiaDetailCT.indexOf(item, 0);
			this.YCDG.YeuCauDuyetGiaDetailCT[index].GiaMoi = this.formatComparenumber(event.target.value);
			this.YCDG.YeuCauDuyetGiaDetailCT[index].ThanhTien = this.YCDG.YeuCauDuyetGiaDetailCT[index].GiaMoi * this.YCDG.YeuCauDuyetGiaDetailCT[index].SoLuong;
			this.YCDG.YeuCauDuyetGiaDetailCT[index].ThanhTienQuyDoi = this.formatComparenumber(controls['TYGIA'].value) * this.YCDG.YeuCauDuyetGiaDetailCT[index].ThanhTien;
			let it = this.YCDG.YeuCauDuyetGiaDetailCT;
			this.YCDG.YeuCauDuyetGiaDetailCT = [];
			this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
		}
		this.changeDetect.detectChanges();
	}
	changeInputNumber(event, min: number = 0) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }
			let data = Number(event.target.value);
			if (data) {
				if (data < min) data = min;
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				this.changeDetectView();
			}
		}
	}
	changeInputNuberOutInput(event: any, min: number = 0) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = Number(event.target.value);
			if (tmpValue < min) tmpValue = min;
			if (event.target.value) {
				event.target.value = tmpValue
				return;
			}
			event.target.value = min;
		}
		else {
			event.target.value = min;
		}
	}

	updateListMH() {
		let tygia = this.formatComparenumber(this.MainForm.controls['TYGIA'].value.toString());
		this.YCDG.YeuCauDuyetGiaDetailCT.forEach(x => {
			x.ThanhTienQuyDoi = x.ThanhTien * tygia;
			x.TyGia = tygia;
		});
		let it = this.YCDG.YeuCauDuyetGiaDetailCT;
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
		this.changeDetectView();
	}
	changeLT() {
		let tiente = this.payments.find(x => x.Id == Number(this.MainForm.controls['LOAITIEN'].value));
		this.YCDG.YeuCauDuyetGiaDetailCT.forEach(x => {
			if (tiente != undefined)
				x.TienTe_Ten = tiente.Ten;
			x.TienTe_Id = Number('' + this.MainForm.controls['LOAITIEN'].value);
		});
		let it = this.YCDG.YeuCauDuyetGiaDetailCT;
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
		this.changeDetectView();
	}
	changeNgayYeuCauGiaoHang(item) {
		let index = this.YCDG.YeuCauDuyetGiaDetailCT.indexOf(item, 0);
		this.YCDG.YeuCauDuyetGiaDetailCT[index].NgayYeuCauGH = moment(this.YCDG.YeuCauDuyetGiaDetailCT[index].NgayYeuCauGH).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		let it = this.YCDG.YeuCauDuyetGiaDetailCT;
		this.YCDG.YeuCauDuyetGiaDetailCT = [];
		this.YCDG.YeuCauDuyetGiaDetailCT = [...it];
	}
	InBaoGia(type) {
		let __idDG = this.data.data.IdDG;
		this.YeuCauDuyetGiaService.InBaoGia(__idDG, type).subscribe(res => {
			const printContent = document.createElement("Print");
			printContent.innerHTML = res.data;
			const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
			WindowPrt.document.write(printContent.innerHTML);
			WindowPrt.document.close();
			WindowPrt.focus();
			WindowPrt.print();
			WindowPrt.close();
		});
	}
	checkguiin() {
		let c = this.YCDG.YeuCauDuyetGiaDetailCT.find(x => x.TrangThai_Code == this.TinhTrang[3].value);
		return c;
	}
}
